<template>
  <div>
    Authentication complete. You can return to the application. Feel free to close this browser tab.
  </div>
</template>
<script>
import Cookies from "js-cookie";
import store from '../store';

export default {
  name: 'RedirectFromLogin',
  data() {
    return {
      parameterURL: [],
    };
  },
  watch: {
  },
  mounted: async function () {
    let self = this;
    for (let key in self.$route.query) {
      self.parameterURL[key.toLowerCase()] = self.$route.query[key];
    }
    if(self.parameterURL.user == 'true')
    {
      await self.GetUserProfile();
    }
    else if(self.parameterURL.userchat == 'true')
    {
      await self.GetUserChatProfile();
    } 
  },
  methods: {
    async GetUserProfile() {
      let self = this;
      self.$call.GetUserProfile(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            if(dataResponse.data != null)
            {
              var User = dataResponse.data;
              Cookies.set('userId', User.userId);
              Cookies.set('username', User.username);
              Cookies.set('fullName', User.fullName);
              Cookies.set('roleId', User.roleId);
              Cookies.set('authenticated', true);
              store.state.status = 'success';
              store.state.token = User.token;
              store.state.userid = User.userId;
              store.state.username = User.username;
              // store.state.user = response.data.data;
              store.state.fullName = User.fullName;
              store.state.roleId = User.roleId;
              store.state.isLoggedIn = true;
              localStorage.setItem('flag', 'us');
              localStorage.setItem('locale', 'en');
              store.state.languages = 'en';
              // localStorage.setItem("Version", dataResponse.data.version);
              // sessionStorage.setItem("Version", dataResponse.data.version);
              
              // ใน myWindow
              window.onbeforeunload = async function() {
                  // ข้อมูลที่ต้องการส่งกลับ
                  const data = {
                      cookies: document.cookie,
                      sessionUserId: User.userId,
                      sessionUsername: User.username,
                      sessionFullName: User.fullName,
                      sessionRoleId: User.roleId,
                  };
                  // ส่งข้อมูลกลับไปยัง parent window
                  await window.opener.postMessage(data, '*');
              };

            }
            window.close();
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    async GetUserChatProfile() {
      let self = this;
      self.$call.GetUserChatProfile(
          async (dataResponse) => {
            if (dataResponse.status == 0) {
              if(dataResponse.data != null)
              {
                var User = dataResponse.data;
                
                localStorage.setItem('token_Snippet', User.token);
                localStorage.setItem('username_Snippet', User.username);
                localStorage.setItem('email_Snippet', User.email);
                localStorage.setItem('isSnippet', true);

                Cookies.set('token_Snippet', User.token);
                Cookies.set('username_Snippet', User.username);
                Cookies.set('email_Snippet', User.email);
                Cookies.set('isSnippet', true);

                sessionStorage.setItem('token_Snippet', User.token);
                sessionStorage.setItem('username_Snippet', User.username);
                sessionStorage.setItem('email_Snippet', User.email);
                sessionStorage.setItem('isSnippet', true);



                if(window.name == "Popup")
                {
                  // ใน myWindow
                  window.onbeforeunload = async function() {
                      // ข้อมูลที่ต้องการส่งกลับ
                      const data = {
                          cookies: document.cookie,
                          sessionToken: sessionStorage.getItem('token_Snippet'),
                          sessionUsername: sessionStorage.getItem('username_Snippet'),
                          sessionEmail: sessionStorage.getItem('email_Snippet'),
                          sessionIsSnippet: sessionStorage.getItem('isSnippet'),
                      };
                      // ส่งข้อมูลกลับไปยัง parent window
                      await window.opener.postMessage(data, '*');
                  };
                  window.close();
                }
                else
                {
                  try {
                    const data = {
                      cookies: document.cookie,
                      sessionToken: sessionStorage.getItem('token_Snippet'),
                      sessionUsername: sessionStorage.getItem('username_Snippet'),
                      sessionEmail: sessionStorage.getItem('email_Snippet'),
                      sessionIsSnippet: sessionStorage.getItem('isSnippet'),
                    };
                    // ส่งข้อมูลกลับไปยัง parent window
                    await window.opener.postMessage(data, '*');
                    window.close();
                  }
                  catch(err) {
                    window.close();
                  }
                  // if(self.parameterURL.provider != "line")
                  // {
                  //   const data = {
                  //     cookies: document.cookie,
                  //     sessionToken: sessionStorage.getItem('token_Snippet'),
                  //     sessionUsername: sessionStorage.getItem('username_Snippet'),
                  //     sessionEmail: sessionStorage.getItem('email_Snippet'),
                  //     sessionIsSnippet: sessionStorage.getItem('isSnippet'),
                  //   };
                  //   // ส่งข้อมูลกลับไปยัง parent window
                  //   await window.opener.postMessage(data, '*');
                  // }
                }
              }
            }
          },
          (errorResource) => {
            console.error(errorResource);
          }
      );
    },
  },
};
</script>

<style scoped>
</style>
